/* eslint-disable react/prop-types */
export default function EmailField(props) {
  const {label,name,formik,placeholder,disabled=false} = props;
 
  return (
    <>
     {label ?
      <label
              htmlFor="email"
              className="block mb-2 text-sm font-medium text-[#494949]"
            >
              {label}
            </label>
        :null}
            <div className="w-full relative">

            <input
              type="email"
              name={name}
              value={formik.values[name]}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="py-4 px-3 bg-[#E4E6E3] w-full border-none  placeholder:text-info focus:text-info focus:border-none outline-none focus:outline-none focus:ring-0 font-imprima"
              placeholder={placeholder}
              disabled={disabled}
              />
               {formik.touched[name] && formik.errors[name] && (
          <div className=" pt-0 text-[12px] text-red-600 font-imprima">
           {formik.errors[name]}
          </div>
       
        )}
       
              </div>
    </>
  )
}
